<template>
  <v-container grid-list-md>
    <v-app-bar color="transparent" class="page-header-toolbar">
      <h2 class="page-title">
        {{ $t("checklisttemplatecategory.list_title") }}
      </h2>

      <v-spacer></v-spacer>

      <div class="page-actions">
        <router-link :to="BACKEND_URL + '/equipmentchecklist/create'" v-if="$can('checklisttemplatecategory-create')">
          <action-button type="new" />
        </router-link>
      </div>
    </v-app-bar>

    <v-data-table
      :headers="headers"
      :items="checklisttemplatecategories"
      :items-per-page="checklisttemplatecategories.length"
      :options.sync="pagination"
      :footer-props="{
        showFirstLastPage: true,
        'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
        'items-per-page-all-text': $t('global.items_per_page_all_text'),
        'items-per-page-text': $t('global.items_per_page_text'),
        'page-text': $t('global.page_text')
      }"
      :server-items-length="total"
      :loading="show_loading"
      :loading-text="$t('global.loading_text')"
      :no-data-text="$t('global.no_data_text')"
      :no-results-text="$t('global.no_results_text')"
      :must-sort="true"
    >
      <template v-slot:item.template_id="{ item }">
        {{ item.checklist_template ? item.checklist_template.title : "" }}
      </template>

      <template v-slot:item.category_id="{ item }">
        {{ item.equipment_category ? item.equipment_category.category_name : "" }}
      </template>

      <template v-slot:item.actions="{ item }">
        <router-link
          :to="{
            path: BACKEND_URL + '/equipmentchecklist/edit/' + item.id,
            props: { id: item.id }
          }"
          v-if="$can('checklisttemplatecategory-edit')"
        >
          <action-button type="edit" :icon_only="true" small />
        </router-link>

        <action-button type="delete" @click="del(item.id)" v-if="$can('checklisttemplatecategory-delete')" :icon_only="true" small />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import rowsPerPage from "@/mixins/rowsPerPage"
export default {
  name: "checklisttemplatecategoryList",
  mixins: [rowsPerPage],
  data() {
    return {
      url: "",

      checklisttemplatecategories: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_CTC_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      search_params: {}
    }
  },
  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_CTC_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("checklisttemplatecategory.category"),
          value: "category_id"
        },
        {
          text: this.$t("checklisttemplatecategory.name"),
          value: "template_id"
        },
        //{ text: this.$t('checklisttemplatecategory.type'), value: 'type', },
        {
          text: this.$t("global.actions"),
          value: "actions",
          width: "120px",
          align: "end",
          sortable: false
        }
      ]
    }
  },
  mounted() {
    this.url = this.API_URL + "checklist-template-category"
  },
  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.checklisttemplatecategories = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "checklist-template-category/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>
